/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = { 'array': [], 'map': null };
}

module.exports = stackClear;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_stackClear.js
// module id = ./node_modules/react-touch/node_modules/lodash/_stackClear.js
// module chunks = main